class SliderAutoscroll extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[id^="SliderTrack-"]');
    this.slides = Array.from(this.querySelectorAll('.slider-autoscroll__slide'));
    this.dots = Array.from(this.querySelectorAll('.slider-autoscroll__dot'));
    this.prevBtn = this.querySelector('.slider-autoscroll__arrow--prev');
    this.nextBtn = this.querySelector('.slider-autoscroll__arrow--next');

    this.currentIndex = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length <= 1) return;

    this.prevBtn?.addEventListener('click', () => this.goTo(this.currentIndex - 1, true));
    this.nextBtn?.addEventListener('click', () => this.goTo(this.currentIndex + 1, true));

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i, true));
    });

    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    this.setupSwipe();
    this.setupIntersectionObserver();

    if (this.autoplay && !this.prefersReducedMotion) {
      this.startAutoplay();
    }
  }

  setupIntersectionObserver() {
    // Pause autoplay when the slider scrolls out of view (saves resources, avoids odd tab-switch jumps)
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          this.stopAutoplay();
        } else if (this.autoplay && !this.prefersReducedMotion) {
          this.startAutoplay();
        }
      });
    }, { threshold: 0.25 });
    this.observer.observe(this);
  }

  setupSwipe() {
    let startX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      const threshold = 40;

      if (diff > threshold) {
        this.goTo(this.currentIndex + 1, true);
      } else if (diff < -threshold) {
        this.goTo(this.currentIndex - 1, true);
      }
    });
  }

  goTo(index, isManual) {
    const total = this.slides.length;
    this.currentIndex = (index + total) % total;

    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.currentIndex);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.currentIndex);
    });

    if (isManual) {
      // restart the autoplay timer so a manual interaction doesn't get
      // immediately overridden by an autoplay tick a moment later
      this.stopAutoplay();
      if (this.autoplay && !this.prefersReducedMotion) this.startAutoplay();
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.goTo(this.currentIndex + 1, false);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.observer?.disconnect();
  }
}

document.querySelectorAll('.slider-autoscroll').forEach((el) => {
  if (!el.dataset.upgraded) {
    el.dataset.upgraded = 'true';
    Object.setPrototypeOf(el, SliderAutoscroll.prototype);
    el.connectedCallback();
  }
});